// extracted by mini-css-extract-plugin
module.exports = {"container":"RedirectCanceled_container__36ZDJ","content-container":"RedirectCanceled_content-container__3g745"};